import { useSWRMutation } from '@tiger/swr';
import { FC, useState } from 'react';
import { EasyField, useForm } from 'react-bootstrap-formutil';
import Alert from 'components/base/Alert';
import { Fade } from 'components/Transition';
import { NameTypeEnum } from 'types/customer';
import API from 'utils/API';
import FirstName from '../components/FirstName';
import LastName from '../components/LastName';
import RealName from '../components/RealName';
import { BaseRealNameInfoProps } from '../type';
import { handlePinYinFormatter, handlePinYinParser } from './helper';

const CHN: FC<BaseRealNameInfoProps> = ({ disabled }) => {
    const {
        $params: { real_name, first_name, last_name }
    } = useForm();
    const [isPinYinPassed, setIsPinYinPassed] = useState(true);
    const { trigger: triggerCheckPinYin } = useSWRMutation<
        { passed: boolean },
        { first_name: string; last_name: string; real_name: string }
    >(API.CUSTOMER.checkPinYin(), params => API.CUSTOMER.checkPinYin.get({ params }).then(res => res.data));

    const checkPinYin = async () => {
        try {
            if ([real_name, first_name, last_name].every(Boolean)) {
                const { passed } = await triggerCheckPinYin({ first_name, last_name, real_name });

                setIsPinYinPassed(passed);
            }
        } catch {
            // 报错不影响提交流程，不做错误展示
        }
    };

    return (
        <>
            <RealName
                label={__('Name(in Chinese)')}
                onBlur={checkPinYin}
                disabled={disabled}
                customCheck={(value: string) => {
                    // 额外校验只能输入中文
                    const regex = /^[\u4e00-\u9fa5]+$/;

                    if (!regex.test(value)) {
                        return __('请输入中文姓名');
                    }

                    return true;
                }}
            />
            <LastName
                $parser={handlePinYinParser}
                $formatter={handlePinYinFormatter}
                onBlur={checkPinYin}
                disabled={disabled}
            />
            <FirstName
                onBlur={checkPinYin}
                $parser={handlePinYinParser}
                $formatter={handlePinYinFormatter}
                disabled={disabled}
            />
            <Fade in={!isPinYinPassed}>
                <Alert variant="warning">{__('您的姓名拼音需要和姓名匹配')}</Alert>
            </Fade>
            <EasyField name="name_type" $defaultValue={NameTypeEnum.CHN} type="hidden" />
        </>
    );
};

export default CHN;
